import styled from 'styled-components';
const ResultListStyled = styled.div`
  flex-grow: 1;
  .export-wrapper {
    margin: 24px 0;
    padding-left: 32px;
    height: 34px;
    .export {
      width: 107px;
      border-radius: 24px;
      color: #fff;
      .MuiSvgIcon-root {
        margin-right: 6px;
      }
    }
    .Mui-disabled {
      color: #fff !important;
      box-shadow: none;
      background-color: rgb(189, 189, 189) !important;
    }
  }

  .handle_btn {
    padding: 0 24px;
    justify-content: center;
    display: flex;

    .no-drop {
      cursor: not-allowed;
    }

    > div {
      margin-right: 15px;
    }

    .icon {
      /* fill: '#BDBDBD'; */
    }

    .preview {
      cursor: pointer;
    }
    .canClick {
      width: 18px;
      height: 18px;
      vertical-align: middle;
      /* fill: '#1B60AD'; */
      cursor: pointer;
    }
  }
  .hover {
    cursor: pointer;
    position: relative;
    display: block;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    transform: scale(1, 1);
    transition: all 0.3s;
  }
  .hover:hover {
    transform: scale(1.1, 1.1);
    transition: all 0.3s;
  }
`;
export default ResultListStyled;
